module.exports = __webpack_public_path__ + "img/bag.be5030ca.webp";